import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import router from './router';
import VueKeycloakJs from '@dsb-norge/vue-keycloak-js';
import axios from 'axios';


//import VueCoreVideoPlayer from 'vue-core-video-player';
//import vuePlayer  from  '@algoz098/vue-player';
//import Embed from 'v-video-embed';
export const componentBus = new Vue();

Vue.config.productionTip = false;

function tokenInterceptor () {
  axios.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
    return config
  }, error => {
    return Promise.reject(error)
  })
}

//Vue.use(VueCoreVideoPlayer);
//Vue.use(Embed);
//Vue.component(vuePlayer);


Vue.use(VueKeycloakJs,  {
  init: {
    // Use 'login-required' to always require authentication
    // If using 'login-required', there is no need for the router guards in router.js
      //onLoad: 'check-sso',
      onLoad: 'login-required',
      checkLoginIframe: true
  },
  config: {
      realm: 'NextGenCMSRealm',
      
      //url: 'http://localhost:8080/auth',
      
      url: 'https://circular.iccs.gr/auth',   
      clientId: 'cms'
    },
  onReady: (keycloak) => {
    console.log(keycloak);
    tokenInterceptor()
    new Vue({
      vuetify,
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})



/*
new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
*/